// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCheckmark_root__3CFO3"};